import Features from './features';
import PestControl from './pest-control';
import { hasPestControlPlans } from './pest-control/has-pest-control-plans';
import { SoyPhenology } from './phenology';
import PhytosanitaryProfile from './phytosanitary-profile';
import Refuge from './refuge';
import SoyCycle from './soy-cycle';
import SoyDensity from './soy-density';
import SoyPlantingDates from './soy-planting-dates';

const SoyInformationModules = [
    {
        component: SoyPlantingDates,
    },
    {
        component: SoyDensity,
        condition: ({ productRecommendations }) =>
            productRecommendations.some(({ harvestDensity, estimatedYield }) => {
                return Boolean(harvestDensity) && Boolean(estimatedYield);
            }),
    },
    {
        component: SoyPhenology,
        condition: ({ productRecommendations }) => productRecommendations.some(({ phenology }) => Boolean(phenology)),
    },
    {
        component: SoyCycle,
        condition: ({ recommendation, cropConfig, productRecommendations }) => {
            return productRecommendations.find(({ profile: { cycle } }) => Boolean(cycle));
        },
    },
    {
        component: PhytosanitaryProfile,
        condition: ({ productRecommendations }) =>
            productRecommendations.find(({ profile }) => profile.metrics.length > 0),
    },
    {
        component: Features,
        condition: ({ productRecommendations }) =>
            productRecommendations.find(({ profile }) => profile.features.length > 0),
    },
    {
        component: PestControl,
        condition: ({ cropConfig }) => hasPestControlPlans(cropConfig.pestControlPlans),
    },
    {
        component: Refuge,
    },
];

export default SoyInformationModules;
